// extracted by mini-css-extract-plugin
export default {"estTable":"U0EcyzqXnX7gsILRt0LH"};